import React, { useState } from "react";
import { CircularProgress, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./AgencyEmployeeStatusMenu.scss";

const AgencyEmployeeStatusMenu = ({
  status,
  onUpdateStatus,
}: {
  status: string;
  onUpdateStatus: (nextStatus: "active" | "deactivated" | "archived") => Promise<void>;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = Boolean(anchorEl);
  const normalized = (status || "").toLowerCase();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const run = async (nextStatus: "active" | "deactivated" | "archived") => {
    handleClose();
    setIsLoading(true);
    try {
      await onUpdateStatus(nextStatus);
    } finally {
      setIsLoading(false);
    }
  };

  const activateLabel = normalized === "active" ? "Deactivate" : "Activate";
  const activateNext: any = normalized === "active" ? "deactivated" : "active";

  const archiveLabel = normalized === "archived" ? "Unarchive" : "Archive";
  const archiveNext: any = normalized === "archived" ? "active" : "archived";

  return (
    <>
      <div
        className="property-menu-icon"
        onClick={handleClick}
        id="employee-action-btn"
        aria-controls={open ? "employee-action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        {isLoading ? (
          <CircularProgress
            style={{ width: 15, height: 15 }}
            className="circular-progress-action-icon"
          />
        ) : (
          <MoreVertIcon fontSize="small" />
        )}
      </div>

      <Menu
        id="employee-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "employee-action-btn" }}
        className="users-list-menu-icon-menu"
        autoFocus={false}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, borderRadius: 2, minWidth: 160 },
        }}
      >
        <MenuItem onClick={() => run(activateNext)}>{activateLabel}</MenuItem>
        <MenuItem onClick={() => run(archiveNext)}>{archiveLabel}</MenuItem>
      </Menu>
    </>
  );
};

export default AgencyEmployeeStatusMenu;